import { render } from "./AppRoot.vue?vue&type=template&id=05e90c30&scoped=true"
import script from "./AppRoot.vue?vue&type=script&lang=js"
export * from "./AppRoot.vue?vue&type=script&lang=js"

import "./AppRoot.vue?vue&type=style&index=0&id=05e90c30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e90c30"]])

export default __exports__